import styled from 'styled-components';


export const TabSelect = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;

  padding: 30px;

  cursor: pointer;
  user-select: none;

  @media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
    padding: 8px 5px;
  };
  
  &.threed-configurator-menu-stone-group-select {
    @media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
      padding: 30px 5px;
    }

    @media (max-height: ${(props) => props.theme.mediaQueryConstants.veryLowHeight}px) {
      padding: 10px 5px;
    }
  }

  &.threed-configurator-menu-material-group-select {
    @media (max-height: ${(props) => props.theme.mediaQueryConstants.lowHeight}px) {
      padding: 8px 5px;
    }
  }
`

export const TabSelectOption = styled.div`
  width: 100%;
  max-width: 150px;

  background-color: ${ props => props.theme.colors.darkGray };
  
  text-align: center;
  text-transform: uppercase;
  white-space: nowrap;

  padding: 5px;

  border-top: 2px solid ${ props => props.theme.colors.darkGray };
  border-bottom: 2px solid ${ props => props.theme.colors.darkGray };

  &.active {
    background-color: ${ props => props.theme.colors.lightGray };
    color: ${ props => props.theme.colors.fallow };
    border-top: 2px solid ${ props => props.theme.colors.fallow };
    border-bottom: 2px solid ${ props => props.theme.colors.fallow };
  }

  @media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
    background-color: ${ props => props.theme.colors.darkGray };
    
    &.active {
      background-color: ${ props => props.theme.colors.lightGray };
    }
	}
`

export const TabSelectOptionTitle = styled.div`
  font-size: 1rem;
`;

export const TabSelectOptionSubTitle = styled.div`
  font-size: 0.6rem;
  color: black;
`;